const log = require('loglevel')

const config = {
    api: {
        orcV2: process.env.GNOS_ORC_V2_URL,
        orcV1: process.env.GNOS_ORC_V1_URL,
        gnosRest: process.env.GNOS_REST_URL,
        centipedeRest: process.env.CENTIPEDE_REST_URL,
        ciaNewsBase: process.env.CIA_NEWS_URL,
    },
    devTools: process.env.DEV_TOOLS !== 'false', // If value is 'false' return false, any other value return true
    logLevel: log.levels[process.env.LOGLEVEL],
    googleMapsApiKey: process.env.GOOGLE_MAPS_API_KEY,
    googleMapsApiKeyView: process.env.GOOGLE_MAPS_API_KEY_VIEW

}

module.exports = config
